__turbopack_context__.v({
  "applyBar": "recipe-filters-module__ONHOsG__applyBar",
  "applyButton": "recipe-filters-module__ONHOsG__applyButton",
  "backdrop": "recipe-filters-module__ONHOsG__backdrop",
  "badge": "recipe-filters-module__ONHOsG__badge",
  "bar": "recipe-filters-module__ONHOsG__bar",
  "closeButton": "recipe-filters-module__ONHOsG__closeButton",
  "drawerClearAll": "recipe-filters-module__ONHOsG__drawerClearAll",
  "drawerHeader": "recipe-filters-module__ONHOsG__drawerHeader",
  "drawerTitle": "recipe-filters-module__ONHOsG__drawerTitle",
  "fadeIn": "recipe-filters-module__ONHOsG__fadeIn",
  "group": "recipe-filters-module__ONHOsG__group",
  "legend": "recipe-filters-module__ONHOsG__legend",
  "moreButton": "recipe-filters-module__ONHOsG__moreButton",
  "panel": "recipe-filters-module__ONHOsG__panel",
  "pills": "recipe-filters-module__ONHOsG__pills",
  "slideUp": "recipe-filters-module__ONHOsG__slideUp",
  "toggleButton": "recipe-filters-module__ONHOsG__toggleButton",
  "wrap": "recipe-filters-module__ONHOsG__wrap",
});
